import React, { useEffect } from 'react';
import classNames from 'classnames';
import './InPageNotification.scss';

import successIcon from '../../assets/images/check-icon-black.svg';
import infoIcon from '../../assets/images/info-icon-gray.svg';
import warningIcon from '../../assets/images/warningIcon.svg';
import removeIcon from '../../assets/images/remove-icon-borderless.svg';

const NOTIFICATION_DISPLAY_TIME = 4000;
let timeout;

const InPageNotification = ({ data, onClose }) => {
	useEffect(() => {
		if (data.message) {
			clearTimeout(timeout);
			timeout = setTimeout(onClose, NOTIFICATION_DISPLAY_TIME);
		}
	}, [data.message, onClose]);

	useEffect(() => {
		return () => {
			clearTimeout(timeout);
			timeout = null;
		};
	}, []);

	const getNotificationIcon = (messageType) => {
		switch (messageType) {
			case 'error':
				return infoIcon;
			case 'success':
				return successIcon;
			case 'info':
				return infoIcon;
			case 'warning':
				return warningIcon;
			default:
				return null;
		}
	};

	return (
		<div className={classNames('in-page-notification', data.type)}>
			<img className="icon" alt={data.type} src={getNotificationIcon(data.type)} />
			<span className="content">{data.message}</span>
			<button type="button" className="clear-button close-button" onClick={onClose}>
				<img alt="Close Notification" src={removeIcon} />
			</button>
		</div>
	);
};

export default InPageNotification;
